// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3_KYB","content":"Consent_content__tcBUg","footer":"Consent_footer__1xjJN"};